import styled from 'styled-components';

const Spacer = styled.div`
    height: 100px;
`;

export default Spacer;
